/**
 * Rocksoft Locations Settings API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpContext 
        }       from '@angular/common/http';
import { Observable }                                        from 'rxjs';
import { OpenApiHttpParams, QueryParamStyle } from '../query.params';

// @ts-ignore
import { AddVppApplicationToCategoryCommand } from '../model/addVppApplicationToCategoryCommand';
// @ts-ignore
import { CategoryType } from '../model/categoryType';
// @ts-ignore
import { CategoryVppApplicationConfiguration } from '../model/categoryVppApplicationConfiguration';
// @ts-ignore
import { ErrorResponse } from '../model/errorResponse';
// @ts-ignore
import { Operation } from '../model/operation';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';


export interface AddVppApplicationToCategoryRequestParams {
    /**  */
    categoryType: CategoryType;
    /** The persistent category id. */
    categoryId: string;
    /** The command to be able to add an application to the category. */
    addVppApplicationToCategoryCommand?: AddVppApplicationToCategoryCommand;
}

export interface DeleteVppApplicationFromCategoryRequestParams {
    /**  */
    categoryType: CategoryType;
    /** The persistent category id. */
    categoryId: string;
    /** The adamId of the VPP application. */
    adamIdStr: string;
}

export interface GetAllVppApplicationsForCategoryRequestParams {
    /** The type of the category. */
    categoryType: CategoryType;
    /** The persistent id of the category. */
    categoryId: string;
}

export interface GetVppApplicationForCategoryRequestParams {
    /** The type of the category. */
    categoryType: CategoryType;
    /** The persistent category id. */
    categoryId: string;
    /** The adamId of the VPP application. */
    adamIdStr: string;
}

export interface GetVppApplicationsForCategoryRequestParams {
    /** The type of the category. */
    categoryType: CategoryType;
    /** The persistent category id. */
    categoryId: string;
}

export interface UpdateAllVppApplicationsForCategoryRequestParams {
    /**  */
    categoryType: CategoryType;
    /** The persistent id of the category. */
    categoryId: string;
    /** The document that contains information about what to do with the applications. */
    operation?: Array<Operation>;
}

export interface UpdateVppApplicationsForCategoryRequestParams {
    /**  */
    categoryType: CategoryType;
    /** The persistent category id. */
    categoryId: string;
    /** The JSON patch that contains which applications to update. */
    operation?: Array<Operation>;
}


@Injectable({
  providedIn: 'root'
})
export class CategoryVppApplicationConfigurationService extends BaseService {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * Adds a VPP application to this category.
     * @endpoint post /categories/{categoryType}/{categoryId}/integrations/mdm/vpp-applications
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public addVppApplicationToCategory(requestParameters: AddVppApplicationToCategoryRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<CategoryVppApplicationConfiguration>;
    public addVppApplicationToCategory(requestParameters: AddVppApplicationToCategoryRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<CategoryVppApplicationConfiguration>>;
    public addVppApplicationToCategory(requestParameters: AddVppApplicationToCategoryRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<CategoryVppApplicationConfiguration>>;
    public addVppApplicationToCategory(requestParameters: AddVppApplicationToCategoryRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const categoryType = requestParameters?.categoryType;
        if (categoryType === null || categoryType === undefined) {
            throw new Error('Required parameter categoryType was null or undefined when calling addVppApplicationToCategory.');
        }
        const categoryId = requestParameters?.categoryId;
        if (categoryId === null || categoryId === undefined) {
            throw new Error('Required parameter categoryId was null or undefined when calling addVppApplicationToCategory.');
        }
        const addVppApplicationToCategoryCommand = requestParameters?.addVppApplicationToCategoryCommand;

        let localVarHeaders = this.defaultHeaders;

        // authentication (azureb2c) required
        localVarHeaders = this.configuration.addCredentialToHeaders('azureb2c', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/categories/${this.configuration.encodeParam({name: "categoryType", value: categoryType, in: "path", style: "simple", explode: false, dataType: "CategoryType", dataFormat: undefined})}/${this.configuration.encodeParam({name: "categoryId", value: categoryId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/integrations/mdm/vpp-applications`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<CategoryVppApplicationConfiguration>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: addVppApplicationToCategoryCommand,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Deletes the VPP application with the given AdamIdStr from the given category if it exists.
     * @endpoint delete /categories/{categoryType}/{categoryId}/integrations/mdm/vpp-applications/{adamIdStr}
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public deleteVppApplicationFromCategory(requestParameters: DeleteVppApplicationFromCategoryRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any>;
    public deleteVppApplicationFromCategory(requestParameters: DeleteVppApplicationFromCategoryRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<any>>;
    public deleteVppApplicationFromCategory(requestParameters: DeleteVppApplicationFromCategoryRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<any>>;
    public deleteVppApplicationFromCategory(requestParameters: DeleteVppApplicationFromCategoryRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const categoryType = requestParameters?.categoryType;
        if (categoryType === null || categoryType === undefined) {
            throw new Error('Required parameter categoryType was null or undefined when calling deleteVppApplicationFromCategory.');
        }
        const categoryId = requestParameters?.categoryId;
        if (categoryId === null || categoryId === undefined) {
            throw new Error('Required parameter categoryId was null or undefined when calling deleteVppApplicationFromCategory.');
        }
        const adamIdStr = requestParameters?.adamIdStr;
        if (adamIdStr === null || adamIdStr === undefined) {
            throw new Error('Required parameter adamIdStr was null or undefined when calling deleteVppApplicationFromCategory.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (azureb2c) required
        localVarHeaders = this.configuration.addCredentialToHeaders('azureb2c', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/categories/${this.configuration.encodeParam({name: "categoryType", value: categoryType, in: "path", style: "simple", explode: false, dataType: "CategoryType", dataFormat: undefined})}/${this.configuration.encodeParam({name: "categoryId", value: categoryId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/integrations/mdm/vpp-applications/${this.configuration.encodeParam({name: "adamIdStr", value: adamIdStr, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<any>('delete', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Gets all the VPP applications that are configured for category with the given categoryId. This includes all the versions that are configured.
     * @endpoint get /categories/{categoryType}/{categoryId}/integrations/mdm/vpp-applications/all
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public getAllVppApplicationsForCategory(requestParameters: GetAllVppApplicationsForCategoryRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<Array<CategoryVppApplicationConfiguration>>;
    public getAllVppApplicationsForCategory(requestParameters: GetAllVppApplicationsForCategoryRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Array<CategoryVppApplicationConfiguration>>>;
    public getAllVppApplicationsForCategory(requestParameters: GetAllVppApplicationsForCategoryRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Array<CategoryVppApplicationConfiguration>>>;
    public getAllVppApplicationsForCategory(requestParameters: GetAllVppApplicationsForCategoryRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const categoryType = requestParameters?.categoryType;
        if (categoryType === null || categoryType === undefined) {
            throw new Error('Required parameter categoryType was null or undefined when calling getAllVppApplicationsForCategory.');
        }
        const categoryId = requestParameters?.categoryId;
        if (categoryId === null || categoryId === undefined) {
            throw new Error('Required parameter categoryId was null or undefined when calling getAllVppApplicationsForCategory.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (azureb2c) required
        localVarHeaders = this.configuration.addCredentialToHeaders('azureb2c', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/categories/${this.configuration.encodeParam({name: "categoryType", value: categoryType, in: "path", style: "simple", explode: false, dataType: "CategoryType", dataFormat: undefined})}/${this.configuration.encodeParam({name: "categoryId", value: categoryId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/integrations/mdm/vpp-applications/all`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<Array<CategoryVppApplicationConfiguration>>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Gets a specific VPP application of this category.
     * @endpoint get /categories/{categoryType}/{categoryId}/integrations/mdm/vpp-applications/{adamIdStr}
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public getVppApplicationForCategory(requestParameters: GetVppApplicationForCategoryRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<CategoryVppApplicationConfiguration>;
    public getVppApplicationForCategory(requestParameters: GetVppApplicationForCategoryRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<CategoryVppApplicationConfiguration>>;
    public getVppApplicationForCategory(requestParameters: GetVppApplicationForCategoryRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<CategoryVppApplicationConfiguration>>;
    public getVppApplicationForCategory(requestParameters: GetVppApplicationForCategoryRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const categoryType = requestParameters?.categoryType;
        if (categoryType === null || categoryType === undefined) {
            throw new Error('Required parameter categoryType was null or undefined when calling getVppApplicationForCategory.');
        }
        const categoryId = requestParameters?.categoryId;
        if (categoryId === null || categoryId === undefined) {
            throw new Error('Required parameter categoryId was null or undefined when calling getVppApplicationForCategory.');
        }
        const adamIdStr = requestParameters?.adamIdStr;
        if (adamIdStr === null || adamIdStr === undefined) {
            throw new Error('Required parameter adamIdStr was null or undefined when calling getVppApplicationForCategory.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (azureb2c) required
        localVarHeaders = this.configuration.addCredentialToHeaders('azureb2c', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/categories/${this.configuration.encodeParam({name: "categoryType", value: categoryType, in: "path", style: "simple", explode: false, dataType: "CategoryType", dataFormat: undefined})}/${this.configuration.encodeParam({name: "categoryId", value: categoryId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/integrations/mdm/vpp-applications/${this.configuration.encodeParam({name: "adamIdStr", value: adamIdStr, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<CategoryVppApplicationConfiguration>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Gets the VPP applications of this category.
     * @endpoint get /categories/{categoryType}/{categoryId}/integrations/mdm/vpp-applications
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public getVppApplicationsForCategory(requestParameters: GetVppApplicationsForCategoryRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<Array<CategoryVppApplicationConfiguration>>;
    public getVppApplicationsForCategory(requestParameters: GetVppApplicationsForCategoryRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Array<CategoryVppApplicationConfiguration>>>;
    public getVppApplicationsForCategory(requestParameters: GetVppApplicationsForCategoryRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Array<CategoryVppApplicationConfiguration>>>;
    public getVppApplicationsForCategory(requestParameters: GetVppApplicationsForCategoryRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const categoryType = requestParameters?.categoryType;
        if (categoryType === null || categoryType === undefined) {
            throw new Error('Required parameter categoryType was null or undefined when calling getVppApplicationsForCategory.');
        }
        const categoryId = requestParameters?.categoryId;
        if (categoryId === null || categoryId === undefined) {
            throw new Error('Required parameter categoryId was null or undefined when calling getVppApplicationsForCategory.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (azureb2c) required
        localVarHeaders = this.configuration.addCredentialToHeaders('azureb2c', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/categories/${this.configuration.encodeParam({name: "categoryType", value: categoryType, in: "path", style: "simple", explode: false, dataType: "CategoryType", dataFormat: undefined})}/${this.configuration.encodeParam({name: "categoryId", value: categoryId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/integrations/mdm/vpp-applications`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<Array<CategoryVppApplicationConfiguration>>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Updates the VPP applications configured to category. This includes all the versions that are configured.
     * The JSON Patch document targets a nested object keyed by Adam ID and version.
     * @endpoint patch /categories/{categoryType}/{categoryId}/integrations/mdm/vpp-applications/all
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public updateAllVppApplicationsForCategory(requestParameters: UpdateAllVppApplicationsForCategoryRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<CategoryVppApplicationConfiguration>;
    public updateAllVppApplicationsForCategory(requestParameters: UpdateAllVppApplicationsForCategoryRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<CategoryVppApplicationConfiguration>>;
    public updateAllVppApplicationsForCategory(requestParameters: UpdateAllVppApplicationsForCategoryRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<CategoryVppApplicationConfiguration>>;
    public updateAllVppApplicationsForCategory(requestParameters: UpdateAllVppApplicationsForCategoryRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const categoryType = requestParameters?.categoryType;
        if (categoryType === null || categoryType === undefined) {
            throw new Error('Required parameter categoryType was null or undefined when calling updateAllVppApplicationsForCategory.');
        }
        const categoryId = requestParameters?.categoryId;
        if (categoryId === null || categoryId === undefined) {
            throw new Error('Required parameter categoryId was null or undefined when calling updateAllVppApplicationsForCategory.');
        }
        const operation = requestParameters?.operation;

        let localVarHeaders = this.defaultHeaders;

        // authentication (azureb2c) required
        localVarHeaders = this.configuration.addCredentialToHeaders('azureb2c', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/categories/${this.configuration.encodeParam({name: "categoryType", value: categoryType, in: "path", style: "simple", explode: false, dataType: "CategoryType", dataFormat: undefined})}/${this.configuration.encodeParam({name: "categoryId", value: categoryId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/integrations/mdm/vpp-applications/all`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<CategoryVppApplicationConfiguration>('patch', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: operation,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Updates VPP applications of this category.
     * The JSON Patch document targets a nested object keyed by Adam ID and version.
     * @endpoint patch /categories/{categoryType}/{categoryId}/integrations/mdm/vpp-applications
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public updateVppApplicationsForCategory(requestParameters: UpdateVppApplicationsForCategoryRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<CategoryVppApplicationConfiguration>;
    public updateVppApplicationsForCategory(requestParameters: UpdateVppApplicationsForCategoryRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<CategoryVppApplicationConfiguration>>;
    public updateVppApplicationsForCategory(requestParameters: UpdateVppApplicationsForCategoryRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<CategoryVppApplicationConfiguration>>;
    public updateVppApplicationsForCategory(requestParameters: UpdateVppApplicationsForCategoryRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const categoryType = requestParameters?.categoryType;
        if (categoryType === null || categoryType === undefined) {
            throw new Error('Required parameter categoryType was null or undefined when calling updateVppApplicationsForCategory.');
        }
        const categoryId = requestParameters?.categoryId;
        if (categoryId === null || categoryId === undefined) {
            throw new Error('Required parameter categoryId was null or undefined when calling updateVppApplicationsForCategory.');
        }
        const operation = requestParameters?.operation;

        let localVarHeaders = this.defaultHeaders;

        // authentication (azureb2c) required
        localVarHeaders = this.configuration.addCredentialToHeaders('azureb2c', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/categories/${this.configuration.encodeParam({name: "categoryType", value: categoryType, in: "path", style: "simple", explode: false, dataType: "CategoryType", dataFormat: undefined})}/${this.configuration.encodeParam({name: "categoryId", value: categoryId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/integrations/mdm/vpp-applications`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<CategoryVppApplicationConfiguration>('patch', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: operation,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

}
